import { render } from "./RastreabilidadeLoteIndex.vue?vue&type=template&id=556d41e4&scoped=true&ts=true"
import script from "./RastreabilidadeLoteIndex.vue?vue&type=script&lang=ts"
export * from "./RastreabilidadeLoteIndex.vue?vue&type=script&lang=ts"

import "./RastreabilidadeLoteIndex.vue?vue&type=style&index=0&id=556d41e4&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556d41e4"]])

export default __exports__